import { createAction } from '@helpers/createAction'

export const INTRO_VIDEOS = 'INTRO_VIDEOS'

export default {
  [INTRO_VIDEOS]: createAction(INTRO_VIDEOS),
}
